import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline/index.js';
import { getBusinessUrl } from '../lib/useBusinessNavigate.js';

const Breadcrumb = ({ crumbs, className }) => {
    return (
        <div className={`flex items-center ${className}`}>
            {crumbs.map((crumb, idx) => (
                <div className="flex items-center" key={idx}>
                    <Link
                        to={getBusinessUrl(crumb.href)}
                        className="no-underline mr-1"
                    >
                        {crumb.name}
                    </Link>
                    <ChevronRightIcon className="w-4 h-4 text-gray-400 mr-1" />
                </div>
            ))}
        </div>
    );
};

export default Breadcrumb;
